// extracted by mini-css-extract-plugin
export var chatHtmlText = "_l2-2";
export var chatLink = "_l2-0";
export var chatText = "_l2-1";